/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AssetMiniReference,
    AssetMiniReferenceFromJSON,
    AssetMiniReferenceFromJSONTyped,
    AssetMiniReferenceToJSON,
    MediaRootMiniReference,
    MediaRootMiniReferenceFromJSON,
    MediaRootMiniReferenceFromJSONTyped,
    MediaRootMiniReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface SubclipPartialUpdate
 */
export interface SubclipPartialUpdate {
    /**
     * 
     * @type {AssetMiniReference}
     * @memberof SubclipPartialUpdate
     */
    asset?: AssetMiniReference;
    /**
     * 
     * @type {AssetMiniReference}
     * @memberof SubclipPartialUpdate
     */
    rendered?: AssetMiniReference;
    /**
     * 
     * @type {boolean}
     * @memberof SubclipPartialUpdate
     */
    shared?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SubclipPartialUpdate
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof SubclipPartialUpdate
     */
    tIn?: number;
    /**
     * 
     * @type {number}
     * @memberof SubclipPartialUpdate
     */
    tOut?: number;
    /**
     * 
     * @type {MediaRootMiniReference}
     * @memberof SubclipPartialUpdate
     */
    root: MediaRootMiniReference;
}

export function SubclipPartialUpdateFromJSON(json: any): SubclipPartialUpdate {
    return SubclipPartialUpdateFromJSONTyped(json, false);
}

export function SubclipPartialUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubclipPartialUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'asset': !exists(json, 'asset') ? undefined : AssetMiniReferenceFromJSON(json['asset']),
        'rendered': !exists(json, 'rendered') ? undefined : AssetMiniReferenceFromJSON(json['rendered']),
        'shared': !exists(json, 'shared') ? undefined : json['shared'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'tIn': !exists(json, 't_in') ? undefined : json['t_in'],
        'tOut': !exists(json, 't_out') ? undefined : json['t_out'],
        'root': MediaRootMiniReferenceFromJSON(json['root']),
    };
}

export function SubclipPartialUpdateToJSON(value?: SubclipPartialUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'asset': AssetMiniReferenceToJSON(value.asset),
        'rendered': AssetMiniReferenceToJSON(value.rendered),
        'shared': value.shared,
        'name': value.name,
        't_in': value.tIn,
        't_out': value.tOut,
        'root': MediaRootMiniReferenceToJSON(value.root),
    };
}


